export default {
	publishableKey: process.env.REACT_APP_PUBLISHABLE_KEY,
};
